import { Spinner } from 'components/Spinner';
import { useOrgRedirect } from './utils';

export default function OrgRedirect() {
  useOrgRedirect();
  return <Spinner />;
}
